export default {
    image: {
        label: 'Image upload',
        error: {
            required: 'Please add a picture (JPG, PNG or GIF)'
        }
    },
    challengesAndOpportunities: {
        label: 'Challenges and Opportunities',
        add: 'Add Challenges and Opportunities',
        remove: 'Remove Challenges and Opportunities',
        empty: 'There are no entries yet',
        expansion: 'Challenges and Opportunities, entry #{cnt}',
        locale: {
            de: 'german',
            en: 'english'
        },
        error: {
            invalid_child: 'At least one of the translations has an error'
        },
        industryId: {
            label: 'Industry selection',
            error: {
                required: 'Please select an industry'
            }
        },
        title: {
            label: 'Title',
            error: {
                required: 'Please add a title'
            }
        },
        challenges: {
            label: 'Challenge',
            error: {
                required: 'Please add a challenge'
            }
        },
        opportunities: {
            label: 'Opportunity',
            error: {
                required: 'Please add an opportunity'
            }
        }
    },
    driver: {
        label: 'Driver',
        empty: 'No driver has been added yet',
        add: 'Add Driver',
        remove: 'Remove Driver',
        expansion: 'Driver, entry #{cnt}'
    },
    translations: {
        label: 'Title and description',
        locale: {
            de: 'german',
            en: 'english'
        },
        error: {
            invalid_child: 'At least one of the translations has an error',
            one_required: 'At least one translation should be created'
        },
        title: {
            label: 'Title',
            error: {
                required: 'Please enter a title'
            }
        },
        description: {
            label: 'Description',
            error: {
                required: 'Please add a description'
            }
        }
    },
    megatrendId: {
        label: 'Mega trend',
        placeholder: 'Mega trend selection',
        inactive: ' (inactive)',
        error: {
            required: 'Please select a mega trend'
        }
    },
    relatedMacrotrendIds: {
        label: 'Linked Macro trends',
        placeholder: 'Linked Macro trend selection',
        deprecated: '(deprecated)'
    },
    active: {
        label: 'Status',
        value: {
            on: 'active',
            off: 'inactive'
        }
    },
    search: {
        close: 'Close',
        label: 'Search parameters',
        result: {
            text: 'Based on the selected search query, no micro-trend hits were found in the Trendfinder.|Based on the selected search query, one micro-trend hit was found in the Trendfinder.|Based on the selected search query, {total} micro-trend hits were found in the Trendfinder.',
            link: 'View all'
        },
        query: {
            label: 'Keyword search',
            add: 'Click here to add the search term'
        },
        facet: {
            placeholder: 'Search',
            megatrends: 'Trends',
            regions: 'Regions',
            industries: 'Industries',
            innovationType: 'Innovations-types',
            sdgs: 'SDGs'
        }
    },
    cancel: 'Cancel',
    submit: 'Submit'
}
